import React from "react";
import "./HouseRulesSection.css";
import * as Icons from "../Icons";

const HouseRulesSection: React.FC = () => {
  const houseRules = [
    {
      id: 1,
      icon: <Icons.NoSmoking />,
      description: "Rauchen ist im gesamten Innenbereich nicht gestattet",
    },
    {
      id: 2,
      icon: <Icons.NoPets />,
      description: "Haustiere sind nicht gestattet",
    },
    {
      id: 3,
      icon: <Icons.NoParty />,
      description: "Partys sind nicht erlaubt",
    },
  ];

  return (
    <section className="section bg-light py-5">
      <div className="container">
        <div className="row justify-content-center text-center mb-5">
          <div className="col-md-7">
            <h2 className="heading" data-aos="fade-up">
              Hausregeln
            </h2>
            <p data-aos="fade-up" data-aos-delay="100">
              Für einen angenehmen Aufenthalt bitten wir um Beachtung der
              folgenden Regeln:
            </p>
          </div>
        </div>

        <div className="row g-3 justify-content-center">
          {houseRules.map((item) => (
            <div key={item.id} className="col-12 col-sm-4 mb-2">
              <div className="d-flex flex-column align-items-center text-center">
                <div
                  className="eq-icon mb-3 house-rules-icon"
                  style={{ fontSize: "3rem" }}
                >
                  {item.icon}
                </div>
                <div className="eq-description">{item.description}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HouseRulesSection;
